import { createFileRoute } from "@tanstack/react-router"
import { enforceSignupStep } from "@/features/registration-workflow"
import { SignupHeardAboutPage } from "@/pages/onboarding"

export const Route = createFileRoute("/onboarding/signup-heard-about")({
	beforeLoad: () => enforceSignupStep("heard-about"),
	component: SignupHeardAboutPage,
})
